import * as React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

class Summary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: null,
    };

    // DATA LOAD
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.props.setHeader({
      title: `${this.props.match.params.id} Limit Config`,
      description: "",
    });
    this.loadData();
  }

  loadData() {
    this.props.load_data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          data: fetchMoreResult.merchant_limit_configurations[0],
        });
      },
    });
  }

  render() {
    const data = this.state.data ? this.state.data : null;

    //  FORMAT DATE
    const formatDate = (date) => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    // DETAILS
    const showData = () => {
      if (data) {
        return (
          <tbody>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>Date:</td>
              <td style={{ padding: "5px" }}>
                {" "}
                {formatDate(data.created_at)}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>Name:</td>
              <td style={{ padding: "5px" }}> {data.name} </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>Description:</td>
              <td style={{ padding: "5px" }}> {data.description} </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max count per day:
              </td>
              <td style={{ padding: "5px" }}> {data.max_count_per_day} </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max count per device per day:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                {data.max_count_per_device_per_day}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max count per device per day with 3ds:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                {data.max_count_per_device_per_day_with_3ds}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max count per hour:
              </td>
              <td style={{ padding: "5px" }}> {data.max_count_per_hour} </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max count per week:
              </td>
              <td style={{ padding: "5px" }}> {data.max_count_per_week} </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max unsettled balance:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(data.max_unsettled_balance, 10) / 100).toFixed(
                  2
                )}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max volume per day:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(data.max_volume_per_day, 10) / 100).toFixed(2)}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max volume per device per day:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R
                {(
                  parseInt(data.max_volume_per_device_per_day, 10) / 100
                ).toFixed(2)}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max volume per device per day with 3ds:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R
                {(
                  parseInt(data.max_volume_per_device_per_day_with_3ds, 10) /
                  100
                ).toFixed(2)}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max volume per device per month:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R
                {(
                  parseInt(data.max_volume_per_device_per_month, 10) / 100
                ).toFixed(2)}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max volume per device per month with 3ds:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R
                {(
                  parseInt(data.max_volume_per_device_per_month_with_3ds, 10) /
                  100
                ).toFixed(2)}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max volume per hour:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(data.max_volume_per_hour, 10) / 100).toFixed(
                  2
                )}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                Max volume per week:
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(data.max_volume_per_week, 10) / 100).toFixed(
                  2
                )}{" "}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                User limits ratio:
              </td>
              <td style={{ padding: "5px" }}> {data.user_limits_ratio} </td>
            </tr>
          </tbody>
        );
      } else {
        return null;
      }
    };

    return (
      <section className="padded scrollable">
        <div>
          <table
            style={{
              fontSize: "14px",
              paddingTop: "10px",
            }}
            cellPadding={0}
          >
            <thead>
              <tr>
                <td colSpan={2}>
                  <h3
                    style={{
                      borderBottom: "1px solid rgb(204, 204, 204)",
                      paddingBottom: "10px",
                      fontWeight: 100,
                      marginTop: "0",
                    }}
                  >
                    Details
                  </h3>
                </td>
              </tr>
            </thead>
            {showData()}
          </table>
        </div>
      </section>
    );
  }
}

// QUERIES
const loadData = graphql(
  gql`
    query data($name: String) {
      merchant_limit_configurations(name: $name) {
        created_at
        description
        max_count_per_day
        max_count_per_device_per_day
        max_count_per_device_per_day_with_3ds
        max_count_per_hour
        max_count_per_week
        max_unsettled_balance
        max_volume_per_day
        max_volume_per_device_per_day
        max_volume_per_device_per_day_with_3ds
        max_volume_per_device_per_month
        max_volume_per_device_per_month_with_3ds
        max_volume_per_hour
        max_volume_per_week
        name
        user_limits_ratio
      }
    }
  `,
  {
    name: "load_data",
    options(props: any) {
      return {
        variables: {
          name: props.match.params.id,
        },
      };
    },
  }
);

const userSummary = compose(loadData)(Summary);
export default userSummary;
